import React, { Fragment, useEffect, useState } from 'react'
import { Button } from 'reactstrap'
import { connect } from 'react-redux'
import { Link, useHistory } from 'react-router-dom'
import * as R from 'ramda'
import { pathOr } from 'ramda'
import { selectCategory } from '../../actions'
import './MarketsServed.scss'
import { documentToReactComponents } from '@contentful/rich-text-react-renderer'

export const MarketsServedServices = ({ data, categories }) => {
  const { services, title } = data
  const [selectedTabId, setSelectedTabId] = useState('primaryCare', ['id'], services.tabId)

  const setActiveTab = selectedTabId => setSelectedTabId(selectedTabId)

  const setMobileActiveTab = selectedTabId =>
    setSelectedTabId(selectedTabId === selectedTabId ? '' : selectedTabId)

  const selectCategory = catId => {
    const selectedCategory = R.find(R.propEq(Number(catId), 'id'))(categories)
    selectCategory(selectedCategory)
  }

  const history = useHistory()

  const handleClick = url => {
    // selectCategory(url);
    history.push(`/${url}`)
  }

  if (services.length === 0) {
    return <div></div>
  }
  return (
    <Fragment>
      <div className="markets-served">
        {/* <!--Services--> */}
        <section className="container-fluid markets-served-services-section-wrapper">
          <div className="row">
            <div className="markets-served-services-title">{title}</div>

            {/* <!-- FOR NON-MOBILE USE ONLY --> */}
            {/* <!--Market Tab Navbar --> */}
            <div className="markets-served-services-section markets-served-services-section-non-mobile">
              {/* <!-- Nav tabs --> */}
              <ul className="nav nav-tabs" role="tablist">
                {services
                  .map(i => i.fields)
                  .map((i, index) => {
                    return (
                      <li key={index} className="nav-item">
                        <div
                          className={`markets-served-services-section-nav-link nav-link  ${
                            selectedTabId === i.tabId ? 'active' : ''
                          }`}
                          data-toggle="tab"
                          aria-selected="true"
                          onClick={() => setActiveTab(i.tabId)}
                        >
                          <div className="row markets-served-services-icon-wrapper">
                            <img
                              className="markets-served-services-icon"
                              src={i.iconImage?.fields.file.url}
                              alt={i.altImageText}
                              loading="lazy"
                            />
                          </div>
                          <div className="row markets-served-services-icon-text-wrapper">
                            <p className="markets-served-services-icon-text">{i.title}</p>
                          </div>
                        </div>
                      </li>
                    )
                  })}
              </ul>

              {/* <!-- Tab panes --> */}
              <div className="tab-content">
                {services
                  .map(i => i.fields)
                  .map((i, index) => {
                    return (
                      <div
                        key={index}
                        className={`tab-pane fade ${
                          selectedTabId === i.tabId ? 'show active' : ''
                        } markets-served-services-wrapper`}
                        id={i.tabId}
                      >
                        <div className="markets-served-sevices-right-side">
                          <div className="markets-served-sevices-title">{i.title}</div>
                          <div className="markets-served-sevices-descriptionOne">
                            {documentToReactComponents(i.descriptionOne)}
                          </div>
                          <div className="markets-served-sevices-descriptionTwo">
                            {documentToReactComponents(i.descriptionTwo)}
                          </div>
                          {/* Button will not work on development per category ID's are set up for production */}
                          <Button
                            type="button"
                            color="primary"
                            className="markets-served-sevices-button"
                            id={i.buttonLink}
                            onClick={() => handleClick(i.tabCatId)}
                          >
                            {i.buttonText}
                          </Button>
                        </div>
                        <div className="markets-served-sevices-left-side">
                          <img
                            className="markets-served-sevices-image"
                            src={i.image?.fields.file.url}
                            alt={i.altImageText}
                            loading="lazy"
                          />
                        </div>
                      </div>
                    )
                  })}
              </div>
            </div>
            {/* <!--End Market Tab Navbar--> */}

            {/* <!-- FOR MOBILE USE ONLY --> */}
            {/* <!--Market Tab Navbar --> */}
            {/* <div className="markets-served-services-section markets-served-services-section-mobile">
                <ul className="nav" role="tablist">
                  {services.map(i => i.fields).map((i, index) => {
                    return (
                      <Fragment key={index}>
                        <li className={`row markets-served-nav-tabs-wrapper ${i.tabId}`} aria-expanded={selectedTabId === i.tabId} onClick={() => setMobileActiveTab(i.tabId)}>
                          <div className="col-12 markets-served-mobile-nav-tabs">
                            <span className="markets-served-sevices-image-wrapper">
                              <img className="markets-served-services-icon-mobile text-left" src={i.iconImage?.fields.file.url} alt={i.altImageText} loading="lazy"/>
                            </span>
                            <p className="markets-served-services-icon-text-mobile text-left">{i.title}</p>
                            <span className="icon-carousel-right-arrow"><span className="mdi mdi-chevron-right" /></span>
                          </div>
                        </li>
                        <div className={`row tab-pane markets-served-services-wrapper-mobile markets-served-blind-content ${selectedTabId === i.tabId ? 'active' : 'collapse'}`}>
                          <div className="col">
                            <div className="markets-served-sevices-descriptionOne">{documentToReactComponents(i.descriptionOne)}</div>
                            <div className="markets-served-sevices-descriptionTwo">{documentToReactComponents(i.descriptionTwo)}</div>
                            <img className="markets-served-sevices-image" src={i.image?.fields.file.url} alt={i.alt} loading="lazy"/>
                            <Link onClick={() => selectCategory(i.tabCatId)} to={`/category/${i.tabCatId}`}>
                              <Button type='button' color="primary" className="markets-served-sevices-button" id={i.buttonLink}>{i.buttonText}</Button>
                            </Link>
                          </div>
                        </div>
                      </Fragment>
                    )
                  })}
                </ul>
              </div> */}
            {/* <!--End Market Tab Navbar--> */}
          </div>
        </section>
        {/* <!--End Services--> */}
      </div>
    </Fragment>
  )
}

const mapStateToProps = state => {
  return {
    categories: state.shopping.categories,
  }
}

export default connect(mapStateToProps, { selectCategory })(MarketsServedServices)
